import { useAvailabilityExceptionRequestsByEmployeeIdQuery } from '../gql/graphql.generated';

export const useAvailabilityExceptionRequests = (employeeId?: string) => {
  const [result, refetch] = useAvailabilityExceptionRequestsByEmployeeIdQuery({
    variables: { id: employeeId! },
    pause: !employeeId,
    requestPolicy: 'network-only'
  });

  return {
    requests: result.data?.availabilityExceptionRequestsByEmployeeId ?? [],
    refetch
  };
};
